import { click } from "@testing-library/user-event/dist/click";
import React, { createContext, useReducer } from "react";

export const GraphContext = createContext();

const initialState = {
  graphOptions: {
    type: "Random",
    connection: "Undirected",
    inputField: {
      numNodes: "",
      starNode: "",
      goalNode: "",
    },
    isHuresticDisable: true,
  },
  nodes: [],
  edges: [],
  finalPath: [],
  traverseDetails: [],
  traversingEdge: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_GRAPH_TYPE":
      return {
        ...state,
        graphOptions: {
          ...state.graphOptions,
          type: action.payload,
          inputField: {
            numNodes: "",
            starNode: "",
            goalNode: "",
          },
        },
        nodes: [],
        edges: [],
        finalPath: [],
        traverseDetails: [],
      };
    case "SET_GRAPH_CONNECTION":
      return {
        ...state,
        graphOptions: {
          ...state.graphOptions,
          connection: action.payload,
        },
        finalPath: [],
        traverseDetails: [],
        finalEdge: [],
        traversingEdge: [],
      };
    case "SET_NUM_NODES":
      return {
        ...state,
        nodes: [],
        edges: [],
        traverseDetails: [],
        graphOptions: {
          ...state.graphOptions,
          inputField: {
            ...state.graphOptions.inputField,
            numNodes: action.payload,
            startNode: "",
            goalNode: "",
          },
        },
      };
    case "SET_STAR_NODE":
      var InitialEdge = state.edges.map((edge) => {
        return {
          ...edge,
          color: "white",
          width: 1,
        };
      });
      return {
        ...state,
        traverseDetails: [],
        edges: InitialEdge,
        graphOptions: {
          ...state.graphOptions,
          inputField: {
            ...state.graphOptions.inputField,
            startNode: action.payload,
          },
        },
      };
    case "SET_GOAL_NODE":
      var InitialEdge = state.edges.map((edge) => {
        return {
          ...edge,
          color: "white",
          width: 1,
        };
      });
      return {
        ...state,
        edges: InitialEdge,
        traverseDetails: [],
        graphOptions: {
          ...state.graphOptions,
          inputField: {
            ...state.graphOptions.inputField,
            goalNode: action.payload,
          },
        },
      };
    case "NODE_DATA_WITH_HURISTIC": {
      const randomNumber = String(Math.floor(Math.random() * 18) + 1);

      function heuristic(node, goal) {
        return String(Math.abs(node * goal));
      }
      const addHurestic = state.nodes.map((node) => {
        return {
          ...node,
          label: heuristic(node.id, randomNumber),
        };
      });

      return {
        ...state,
        graphOptions: {
          ...state.graphOptions,
          isHuresticDisable: false,
        },
        nodes: addHurestic,
      };
    }
    case "SET_NODES":
      return {
        ...state,
        nodes: action.payload,
      };
    case "SET_EDGES":
      return {
        ...state,
        edges: action.payload,
      };
    case "SET_EDGES_FINALPATH":
      return {
        ...state,
        traversingEdge: action.payload,
      };

    case "SET_FINAL_PATH":
      return {
        ...state,
        finalPath: action.payload,
      };
    case "SET_TRAVERSE_DETAILS":
      return {
        ...state,
        traverseDetails: action.payload,
      };

    case "RESET":
      return {
        ...state,
        graphOptions: {
          ...state.graphOptions,
          inputField: {
            numNodes: "",
            starNode: "",
            goalNode: "",
          },
        },
        nodes: [],
        edges: [],
        finalPath: [],
        traverseDetails: [],
        traversingEdge: [],
      };

    default:
      return state;
  }
};

const GraphContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setGraphType = (type) => {
    dispatch({ type: "SET_GRAPH_TYPE", payload: type });
  };

  const setGraphConnection = (connection) => {
    dispatch({ type: "SET_GRAPH_CONNECTION", payload: connection });
  };

  const setNumNodes = (numNodes) => {
    dispatch({ type: "SET_NUM_NODES", payload: numNodes });
  };

  const setStartNode = (startNode) => {
    dispatch({ type: "SET_STAR_NODE", payload: startNode });
  };

  const setGoalNode = (goalNode) => {
    dispatch({ type: "SET_GOAL_NODE", payload: goalNode });
  };

  const onGenerateHuristic = () => {
    dispatch({ type: "NODE_DATA_WITH_HURISTIC" });
  };

  const setNodes = (nodes) => {
    dispatch({ type: "SET_NODES", payload: nodes });
  };

  const setEdges = (edges) => {
    dispatch({ type: "SET_EDGES", payload: edges });
  };
  const setEdgeFinalPath = (edges) => {
    dispatch({ type: "SET_EDGES_FINALPATH", payload: edges });
  };
  const setEdgeColor = (edges) => {
    dispatch({ type: "SET_EDGES_COLOR", payload: edges });
  };
  const setFinalPath = (path) => {
    dispatch({ type: "SET_FINAL_PATH", payload: path });
  };
  const setTraverseDetails = (details) => {
    dispatch({ type: "SET_TRAVERSE_DETAILS", payload: details });
  };
  const setTraverseEdge = (details) => {
    dispatch({ type: "SET_TRAVERSE_EDGE", payload: details });
  };
  const reset = () => {
    dispatch({ type: "RESET" });
  };

  return (
    <GraphContext.Provider
      value={{
        graphOptions: state.graphOptions,
        setGraphType,
        setGraphConnection,
        setNumNodes,
        setStartNode,
        setGoalNode,
        onGenerateHuristic,
        setNodes,
        setEdges,
        setFinalPath,
        setTraverseDetails,
        setTraverseEdge,
        setEdgeFinalPath,
        setEdgeColor,
        nodes: state.nodes,
        edges: state.edges,
        finalPath: state.finalPath,
        traverseDetails: state.traverseDetails,
        traversingEdge: state.traversingEdge,
        reset,
      }}
    >
      {props.children}
    </GraphContext.Provider>
  );
};

export default GraphContextProvider;
